import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotFoundComponent } from 'app/not-found/components/not-found/not-found.component';
import { NotFoundRoutingModule } from 'app/not-found/routes/not-found-routing.module';
import { ExpiredAppNotFoundComponent } from 'app/not-found/components/expired-app-not-found/expired-app-not-found.component';

@NgModule({
  imports: [
    CommonModule,
    NotFoundRoutingModule
  ],
  declarations: [NotFoundComponent, ExpiredAppNotFoundComponent]
})
export class NotFoundModule { }
